import DicasOtimizacao from "@pages/DicasOtimizacao";
import { ContextTelaProvider } from "@pages/DicasOtimizacao/telaContext";

export function PostsRoutes() {
  return (
    <ContextTelaProvider>
      <DicasOtimizacao layout="desktop" />
    </ContextTelaProvider>
  );
}
